import store from "store";
const User_Login_Info = "User_Login_Info";
export default {
  saveUserLoginInfo(user) {
    store.set(User_Login_Info, user);
  },
  getUserLoginInfo() {
    return store.get(User_Login_Info) || {};
  },
  removeUserLoginInfo() {
    store.remove(User_Login_Info);
  },
};
